/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1759
 */

"use strict"

var r = require(/* 257 */"./1754/257/index")
var /* [auto-meaningful-name] */require_401_$_1754_401$forEach = require(/* 401 */"./1754/401").forEach
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("forEach", function (e) {
  require_401_$_1754_401$forEach(r$aTypedArray(this), e, arguments.length > 1 ? arguments[1] : undefined)
})
